import { Avatar, Box, Divider, IconButton, Paper, Typography, useTheme } from "@mui/material";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

import { formatDate } from "../../../shared/utils/formatDate";
import { useNavigation } from "../../../hooks/useNavigation";
import { StatusChip } from "../../../shared/components";

import DraftsIcon from '@mui/icons-material/Drafts';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import { Info } from "@mui/icons-material";

export const JeopardyCard = ({ jeopardy, handleMarkAsRead }: { jeopardy: any, handleMarkAsRead: ({ jeopardyId, isRead }: { jeopardyId: string, isRead: boolean }) => Promise<void> }) => {

    const theme = useTheme();
    const { goToJeopardyDetails } = useNavigation();

    return (
        <Paper
            sx={{
                p: 2,
                cursor: 'pointer',
                width: '100%',
                ':hover': { boxShadow: 1 },
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                borderLeft: `6px solid ${jeopardy.is_read ? theme.palette.warning.light : theme.palette.warning.main}`,
            }}
            elevation={2}
            variant="outlined"
            data-background-elevation={1}
            onClick={() => goToJeopardyDetails(jeopardy.id)}
        >

            <Box sx={{ display: 'flex', alignItems: 'center' }}>

                <Avatar sx={{ width: 30, height: 30, mr: 1, color: 'white', bgcolor: jeopardy.is_read ? theme.palette.warning.light : theme.palette.warning.main }}>
                    <NotificationsNoneIcon />
                </Avatar>

                <Box display={'flex'} flexDirection={'column'} alignItems={'start'}>
                    <Typography variant="caption">{jeopardy.category_display_text} - {jeopardy.jeopardy_ref}</Typography>
                    <Typography variant="body2">{jeopardy.details || 'N/A'}</Typography>
                </Box>

                <Box display={'flex'} alignItems={'center'} ml={'auto'} gap={1}>
                    <Info sx={{ color: jeopardy.severity_display_text === 'Average' ? "success.main" : jeopardy.severity_display_text === 'High Risk' ? "warning.main" : "error.main" }} />
                    <Typography variant="body2" flexGrow={1} textAlign={"right"} color={jeopardy.severity_display_text === 'Average' ? "success.main" : jeopardy.severity_display_text === 'High Risk' ? "warning.main" : "error.main"}>
                        {jeopardy.severity_display_text}
                    </Typography>
                </Box>

                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        handleMarkAsRead({ jeopardyId: jeopardy.id, isRead: !jeopardy.is_read });
                    }}
                    sx={{ ml: 1 }}
                    size="small"
                    color="primary"
                >
                    {jeopardy.is_read ? <DraftsIcon /> : <MarkunreadIcon />}
                </IconButton>

            </Box>

            <Divider sx={{ my: 1 }} />

            <Box display={'flex'} justifyContent={'space-between'}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {
                        jeopardy.closed_date && (
                            <>
                                <Typography variant="caption" color="text.secondary">Complete by</Typography>
                                <Typography variant="caption" color="text.primary">{formatDate(jeopardy.closed_date)}</Typography>
                            </>
                        )
                    }
                    <Typography variant="caption" color="text.secondary">Reported on</Typography>
                    <Typography variant="caption" color="text.primary">{formatDate(jeopardy.reported_on)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {jeopardy.overdue && <StatusChip label="Overdue" color="red" variant="outlined" />}
                    <StatusChip label={jeopardy.assigned_to ? "Assigned" : "Unassigned"} color={jeopardy.assigned_to ? "red" : "default"} variant="outlined" />
                </Box>
            </Box>

        </Paper>
    );

};